var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishingElectricity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6184 20.9524C38.6184 31.4721 30.1816 40 19.7743 40C9.36696 40 0.930176 31.4721 0.930176 20.9524C0.930176 10.4327 9.36696 1.90479 19.7743 1.90479C30.1816 1.90479 38.6184 10.4327 38.6184 20.9524Z",
    fill: "#ACABC0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1151_48277",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 25,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73047 0H32.8707V35.8267H8.73047V0Z",
    fill: "#E5E5E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1151_48277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75018 10.8028V30.2533C8.75018 30.3257 8.7483 30.3976 8.7384 30.4695C8.70778 30.6938 8.70213 31.4919 9.98353 32.14C11.4911 32.9019 17.1113 35.6733 17.1113 35.6733C17.1113 35.6733 17.5914 36.019 18.242 35.6733C18.8511 35.3495 29.9159 29.6947 31.3509 28.9619C31.4686 28.9014 31.576 28.8257 31.6726 28.7342C32.0198 28.4057 32.7872 27.5633 32.84 26.4938C32.9088 25.1085 32.84 5.32996 32.84 5.32996C32.84 5.32996 32.9088 4.29091 31.9148 3.77139L24.7531 0.169007C24.7531 0.169007 24.2047 -0.211945 23.4165 0.169007L10.3604 6.78472C10.3604 6.78472 8.75018 7.47758 8.75018 10.8028Z",
    fill: "#E5E5E5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6929 34.9729C15.0381 34.649 15.0381 33.8805 15.0423 33.8443C15.0418 33.6648 15.0668 14.8681 15.0418 12.8914C15.0154 10.8562 16.6167 9.87714 16.6327 9.86762L30.266 2.94238L30.4813 3.05048L16.7279 10.0448C16.7185 10.051 15.2166 10.9733 15.2411 12.889C15.2665 14.8671 15.2411 33.6652 15.2411 33.8548C15.2402 33.8714 15.1766 34.6057 15.7056 34.8671L15.6924 34.9729H15.6929Z",
    fill: "#B2B9C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0383 3.84287C32.0383 3.84287 31.718 3.78478 31.3449 3.96668C30.9727 4.14859 17.8779 10.7857 17.8779 10.7857C17.8779 10.7857 16.4901 11.5395 16.5414 14.4486C16.5933 17.3581 16.5414 34.4 16.5414 34.4C16.5414 34.4 16.499 35.4262 17.1115 35.6733C17.1115 35.6733 17.5972 36.0067 18.2421 35.6733C18.8866 35.3395 31.351 28.9619 31.351 28.9619C31.351 28.9619 32.7799 28.0267 32.8402 26.4943V5.33049C32.8402 5.33049 32.9499 4.37287 32.0383 3.84287Z",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 26.9962L24.8562 12.5781L29.9964 21.9305L20.23 26.9962Z",
    fill: "#74808C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8587 13.0719L25.1648 12.7343L20.5386 27.1519L21.2325 27.4896L30.9989 22.4243L25.8587 13.0719Z",
    fill: "#F39889"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2324 27.4895L25.8586 13.0719L30.9984 22.4238L21.2324 27.4895Z",
    fill: "#F07662"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9739 14.7971L24.4961 20.6552L25.9739 19.9271V23.9538L27.5159 18.1352L26.006 18.9276L25.9739 14.7971Z",
    fill: "#A83D41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2225 14.9338L24.7446 20.7919L25.1135 21.06L26.2225 20.5143V24.0909L26.5914 24.359L28.1333 18.54L27.7644 18.2719L26.6196 18.8728L26.5914 15.2019",
    fill: "#F6F7F7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5906 15.2024L25.1128 21.0605L26.5906 20.3329V24.3595L28.1326 18.5405L26.6227 19.3329L26.5906 15.2024Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishingElectricity);
export default __webpack_public_path__ + "static/media/finishing-electricity.a29a256248318d43d303fdc32265a86a.svg";
export { ForwardRef as ReactComponent };